import { combineReducers } from 'redux';
import zIndex from './zIndex.reducer';

export default combineReducers({
  zIndex,
});
